import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminUsersService } from '../../services/admin-users.service.';
import { AlertDialog } from '../../shared/dialogs/dialog';
import { environment } from './../../../environments/environment';
import { GlobalValidators } from './../../utils/validators';
import { getEncripted } from '../../utils/pw-encripted';
@Component({
  selector: 'app-admin-change-password',
  templateUrl: './admin-change-password.component.html',
  styleUrls: ['./admin-change-password.component.scss'],
})
export class AdminChangePasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  changePWType = false;
  siteKey = environment.siteKey;
  automationEnvirement: any;
  emailAddress: String;
  verificationCode: String;
  isVerificationCodeValid = true;
  siginingInProgress;
  signinFormErrors;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private adminService: AdminUsersService
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.emailAddress = decodeURIComponent(params['email']).replace(/ /g, '+');
      this.verificationCode = params['code'];
    });
  }

  ngOnInit() {
    this.bindForm();

    // this.accountservice.signOut();//check
    this.adminService
      .resetPasswordVerification({
        email: this.emailAddress,
        verificationCode: this.verificationCode,
      })
      .catch((e) => {
        this.isVerificationCodeValid = false;
        AlertDialog('The verification code has expired or is invalid!', 'Change Password', 'Ok');
      });
  }

  reset(form) {
    form.resetForm();
    this.bindForm();
  }

  bindForm() {
    this.changePasswordForm = this.fb.group(
      {
        password: [, [Validators.required, GlobalValidators.password()]],
        confirmPassword: [, [Validators.required]],
      },
      {
        validator: GlobalValidators.misMatchPasswords('password', 'confirmPassword'),
      }
    );
  }

  changePasword(form) {
    if (form.invalid) {
      return;
    }

    this.siginingInProgress = true;
    if (form.value.password === form.value.confirmPassword) {
      let newPw = getEncripted.bind(this)(form.value.confirmPassword);
      this.adminService
        .changePassword({
          email: this.emailAddress,
          verificationCode: this.verificationCode,
          password: newPw,
        })
        .then((data) => {
          this.siginingInProgress = false;
          AlertDialog('New Password Updated', 'Change Password', 'Ok');
          this.router.navigate(['/admin-login']);
          this.reset(form);
        })
        .catch((e) => {
          this.siginingInProgress = false;
          AlertDialog('Password Reset Unsuccessful', 'Change Password', 'Ok');
        });
    }
    this.reset(form);
  }

  displayPassword() {
    this.changePWType = !this.changePWType;
  }
}
